import React, { useState } from "react";
import "./RegistrationForm.css";

export const isYesNoField = (field) => field.type === "select" && field.options?.length === 2
  && field.options.some((option) => option.value === "yes")
  && field.options.some((option) => option.value === "no");

export default function YesNoOptions({
  field, value, onChange, disabled = false, namePrefix = "registration", checkboxStyle = false,
}) {
  const [previewValue, setPreviewValue] = useState(value);
  const selected = onChange ? value : previewValue;
  return <div className={checkboxStyle ? "registration-medical-question" : "registration-row"}>
    <span id={`${namePrefix}-${field.key}-label`} className="text-sm font-medium text-slate-700">{field.label}{field.required ? " *" : ""}</span>
    <fieldset aria-labelledby={`${namePrefix}-${field.key}-label`}
      className={`flex min-w-0 ${checkboxStyle ? "registration-medical-options justify-end" : "items-center gap-4"}`} disabled={disabled}>
      {["yes", "no"].map((answer) => <label key={answer} className={`inline-flex cursor-pointer items-center text-sm text-slate-700 ${checkboxStyle ? "justify-center" : "gap-1.5"}`}>
        <input type={checkboxStyle ? "checkbox" : "radio"} name={checkboxStyle ? undefined : `${namePrefix}-${field.key}`}
          required={checkboxStyle ? field.required && (selected === answer || (!selected && answer === "yes")) : field.required}
          aria-label={checkboxStyle ? `${field.label} - ${answer === "yes" ? "Yes" : "No"}` : undefined}
          value={answer} className={checkboxStyle ? "registration-check-option" : "h-4 w-4 accent-cyan-800"} checked={selected === answer}
          onChange={(event) => {
            const next = checkboxStyle && !event.target.checked ? undefined : answer;
            if (onChange) onChange(field.key, next);
            else setPreviewValue(next);
          }} />
        <span>
          {field.options.find((option) => option.value === answer).label}
        </span>
      </label>)}
    </fieldset>
  </div>;
}
